import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpParamObject } from '../../utility/http-utility/http-param-object.interface';
import { HttpUtilityService } from '../../utility/http-utility/http-utility.service';
import { ProviderDocument } from '../../models/content/provider-document.interface';
import { FileService } from '../file/file.service';

@Injectable({ providedIn: 'root' })
export class ProviderDocumentsService {
	constructor(private readonly http: HttpClient) {}

	getProviderDocumentData(educationalProviderId: number, clientId: number): Observable<Array<ProviderDocument>> {
		const httpParamOptions: HttpParamObject = HttpUtilityService.toPlainHttpParams({ clientId });

		return this.http.get<Array<ProviderDocument>>(
			`educationProviders/${educationalProviderId}/provider-documents`,
			httpParamOptions
		);
	}

	getProviderDocument(providerDocumentFileId: string): Observable<HttpResponse<Blob>> {
		return this.http.get<Blob>(`content/file/${providerDocumentFileId}`, {
			observe: 'response',
			responseType: 'blob' as 'json'
		});
	}

	getProviderDocumentsByProviderId(providerId: number): Observable<Array<ProviderDocument>> {
		return this.http.get<Array<ProviderDocument>>(`content/provider-documents/${providerId}`);
	}

	saveProviderDocument(formData: FormData): Observable<void> {
		return this.http.post<void>(`content/provider-documents`, formData);
	}

	deleteProviderDocumentByFileId(id: string): Observable<void> {
		return this.http.delete<void>(`content/provider-documents/${id}`);
	}

	saveDocument(document: ProviderDocument): void {
		this.getProviderDocument(document.fileId).subscribe((response) => {
			FileService.saveFile(response.body, FileService.getFileName(document.fileName, response));
		});
	}
}
